/** @jsxImportSource @emotion/react */

import React from "react";
import { CustomThemeContext } from "js/common/themes/CustomThemeProvider";

const SimpleTextInput = React.memo(({
  type = "text",
  onChange,
  onKeyPress = () => {},
  customStyle = {},
  ...props
}) => {
  const { theme } = React.useContext(CustomThemeContext);

  const style = {
    ...textInputStyle(theme),
    ...customStyle
  };
  return (
      <input
          type={type}
          onChange={e => onChange(e.target.value, e)}
          onKeyPress={e => onKeyPress(e.key)}
          css={style}
          {...props} />);
});

const textInputStyle = theme => ({
  color: theme.palette.textColor,
  fontSize: "0.875rem",
  fontFamily: "inherit",
  display: "block",
  boxSizing: "border-box",
  width: "100%",
  borderRadius: 3,
  backgroundColor: theme.palette.background.card,
  border: `1px solid ${theme.palette.border.main}`,
  padding: "0.5rem",
  height: 36,
  transition: "box-shadow 0.45s, border-color 0.45s ease-in-out",

  ":active": {
    backgroundColor: theme.palette.background.card,
    outline: "none"
  },

  ":disabled": {
    color: theme.palette.action.disabled
  },

  ":focus": {
    backgroundColor: theme.palette.background.card,
    border: `1px solid ${theme.palette.border.main}`,
    outline: "none"
  }
});

SimpleTextInput.displayName = "SimpleTextInput";

export default SimpleTextInput;
